import Enum from './enum'

class UserRoleType extends Enum
{
  constructor(value) {
    super(value);
  }
}

UserRoleType.init({
  CUSTOMER: 'UserCustomer',
  CONTRACTOR: 'UserParticipant',
  MAIN: 'UserMain',
  COMMISSION: 'UserCommission'
});

export default UserRoleType;
